import httpClient from "../config/HttpClient";
import EntityId from "../EntityId";

export const ATTACHMENTS_URL = "/attachments";

export class AttachmentModel {
  static async storeAttachment(attachment: File): Promise<string> {
    const formData = new FormData();
    formData.append("attachment", attachment);
    
    const response = await httpClient.post<EntityId>(
      `${ATTACHMENTS_URL}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    
    return response.data.id;
  }

  static async deleteAttachment(attachmentId: string): Promise<string> {
    const response = await httpClient.delete<EntityId>(
      `${ATTACHMENTS_URL}/${attachmentId}`
    );
    
    return response.data.id;
  }
}

export default AttachmentModel;
